import { z } from 'zod';

import { fieldNameSecuritySection } from './SectionSecurity.constants';

export const schemaUseSession = z.object({
    [fieldNameSecuritySection.session]: z.boolean(),
});
